<section class="page-content-wrapper" [ngStyle]="{'max-width': contentWidth, 'padding': contentPadding}">
  <ng-content></ng-content>
</section>
